import IComponent from "components/commons/IComponent";
import "../DetailPanels.scoped.css";

class CellTable extends IComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        <table className="ResultInfoTable">
          <tbody>
            {this.props.data.map((i, j) => {
              if (!("tableSpec" in i) && i.alias !== "") {
                return (
                  <tr key={`detailData_` + j} className="ResultInfoRow">
                    <td className="ResultInfoRowHead">{i.alias}</td>
                    <td className="ResultInfoRowValue">{i.value}</td>
                  </tr>
                );
              } else if (!("tableSpec" in i)) {
                return (
                  <tr key={`detailData_` + j} className="ResultInfoRow">
                    <td className="ResultInfoRowHead">{i.value}</td>
                  </tr>
                );
              } else {
                return (
                  <tr key={`detailData_` + j} className="ResultInfoRow">
                    <td className="ResultInfoRowHead">{i.alias}</td>
                    <td className="ResultInfoRowValue">
                      <table className="ResultInfoRowTable">
                        <thead>
                          <tr className="ResultInfoRow">
                            {i.tableSpec.map((c, col_index) => {
                              return (
                                <td key={`detailData_` + j + `_h_` + col_index}>
                                  {c.alias}
                                </td>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {i.tableSpec[0].value.length > 0 ? (
                            i.tableSpec[0].value.map((k, row_index) => {
                              return (
                                <tr
                                  key={`detailData_` + j + `_r_` + row_index}
                                  className="ResultInfoRow"
                                >
                                  {i.tableSpec.map((c, col_index) => {
                                    return (
                                      <td
                                        key={
                                          `detailData_` +
                                          j +
                                          `_c_` +
                                          row_index +
                                          `_` +
                                          col_index
                                        }
                                      >
                                        {c.urlTransform
                                          ? c.urlTransform(c.value[row_index])
                                          : c.value[row_index]}
                                      </td>
                                    );
                                  })}
                                </tr>
                              );
                            })
                          ) : (
                            <tr className="ResultInfoRow">
                              <th colSpan={i.tableSpec.length}>
                                No data available in table
                              </th>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                );
              }
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
export default CellTable;
